export default __webpack_public_path__ + "static/2.20ebd1639c29eff6a7ee57c8f3c3a220.png";